export enum BadgeProvider {
    LAFON = 'LAFON',
    GIR = 'GIR',
    GIR_GNV = 'GIR_GNV',
    GIR_LAFON = 'GIR_LAFON',
    SOGESMATIC = 'SOGESMATIC',
    OTHER = 'OTHER'
}
